import { Injectable, inject } from '@angular/core';
import RestService from '../services/core-rest.service';
import Config from '../utils/config.service';
import AngularBroadcastHelperService from '../services/angular-broadcast-helper.service';

@Injectable({ providedIn: 'root' })
export default class PreVisitRecordTicketForPersonService {
	private restService: RestService = inject(RestService);
	private config: Config = inject(Config);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	RECORD_FOR_PERSON_STORAGE_KEY: any = "record-for-person"
	
	store: any = {
		settings: null,
		patientData: null,
		requesterData: null,
		requesterRelationshipToPatient: null,
		recorderData: null
	};
	
	constructor() {
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Session.LOGOUT, () => { this.clearData(); });
	}
	
	clearData(event?, keepSettings?) {
		if (!keepSettings) {
			this.store.settings = null;
		}
		this.store.patientData = null;
		this.store.requesterData = null;
		this.store.requesterRelationshipToPatient = null;
		this.store.recorderData = null;
		if (!keepSettings) {
			sessionStorage.removeItem(this.RECORD_FOR_PERSON_STORAGE_KEY);
		} else {
			sessionStorage.setItem(this.RECORD_FOR_PERSON_STORAGE_KEY, JSON.stringify(this.store));
		}
		if (!event) {
			// TODO ANGULAR_2 should this be removed since it fails anyways after session detroyed?
			this.restService.updateSessionPreVisitRecordForPatientClearSession()
				.then(() => {
					// do nothing
				})
				.catch((error) => {
					console.log(error);
				});
		}
	}
	
	getSettings() {
		if (!this.store.settings) {
			var storageSessionObj: any = sessionStorage.getItem(this.RECORD_FOR_PERSON_STORAGE_KEY);
			var sessionObj: any = storageSessionObj ? JSON.parse(storageSessionObj) : undefined;
			this.store = sessionObj ? sessionObj : this.store;
		}
		return this.store.settings;
	}

	setSettings(settings) {
		this.store.settings = settings;
		sessionStorage.setItem(this.RECORD_FOR_PERSON_STORAGE_KEY, JSON.stringify(this.store));
	}
	
	getPatient() {
		if (!this.store.patientData) {
			var storageSessionObj: any = sessionStorage.getItem(this.RECORD_FOR_PERSON_STORAGE_KEY);
			var sessionObj: any = storageSessionObj ? JSON.parse(storageSessionObj) : undefined;
			this.store = sessionObj ? sessionObj : this.store;
		}
		return this.store.patientData;
	}
	
	setPatient(patient) {
		this.store.patientData = patient;
		sessionStorage.setItem(this.RECORD_FOR_PERSON_STORAGE_KEY, JSON.stringify(this.store));
	}
	
	updatePatientUser(user) {
		if (this.store.patientData) {
			this.store.patientData.user = user;
			sessionStorage.setItem(this.RECORD_FOR_PERSON_STORAGE_KEY, JSON.stringify(this.store));
		}
	}
	
	getRequester() {
		if (!this.store.requesterData) {
			var storageSessionObj: any = sessionStorage.getItem(this.RECORD_FOR_PERSON_STORAGE_KEY);
			var sessionObj: any = storageSessionObj ? JSON.parse(storageSessionObj) : undefined;
			this.store = sessionObj ? sessionObj : this.store;
		}
		return this.store.requesterData;
	}
	
	setRequester(requester) {
		this.store.requesterData = requester;
		sessionStorage.setItem(this.RECORD_FOR_PERSON_STORAGE_KEY, JSON.stringify(this.store));
	}
	
	getRequesterRelationshipToPatient() {
		if (!this.store.requesterRelationshipToPatient) {
			var storageSessionObj: any = sessionStorage.getItem(this.RECORD_FOR_PERSON_STORAGE_KEY);
			var sessionObj: any = storageSessionObj ? JSON.parse(storageSessionObj) : undefined;
			this.store = sessionObj ? sessionObj : this.store;
		}
		return this.store.requesterRelationshipToPatient;
	}
	
	setRequesterRelationshipToPatient(requesterRelationshipToPatient) {
		this.store.requesterRelationshipToPatient = requesterRelationshipToPatient;
		sessionStorage.setItem(this.RECORD_FOR_PERSON_STORAGE_KEY, JSON.stringify(this.store));
	}
	
	getRequestRecorder() {
		if (!this.store.recorderData) {
			var storageSessionObj: any = sessionStorage.getItem(this.RECORD_FOR_PERSON_STORAGE_KEY);
			var sessionObj: any = storageSessionObj ? JSON.parse(storageSessionObj) : undefined;
			this.store = sessionObj ? sessionObj : this.store;
		}
		return this.store.recorderData;
	}
	
	setRequestRecorder(recorder) {
		this.store.recorderData = recorder;
		sessionStorage.setItem(this.RECORD_FOR_PERSON_STORAGE_KEY, JSON.stringify(this.store));
	}
	
	addRecordTicketForPersonData(submitData) {
		if (this.getPatient()) {
			Object.assign(submitData, { 'patient': this.getPatient().user })
		}
		if (this.getRequester()) {
			Object.assign(submitData, { 'requester': this.getRequester().user })
		}
		if (this.getRequesterRelationshipToPatient()) {
			Object.assign(submitData, { 'requesterRelationshipToPatient': this.getRequesterRelationshipToPatient() })
		}
		if (this.getRequestRecorder()) {
			Object.assign(submitData, { 'requestRecorder': this.getRequestRecorder().user })
		}
		return submitData;
	}
	
}